<div [hidden]="!isShownComment" class="card shadow-none mb-0" style="min-height: calc(100vh - 220px)">
	<div class="card-header">
		<h6 class="card-title">Commentaires</h6>
	</div>
	<div class="card-body">
		<!-- Commentaires list ========== -->
		<div class="card shadow-none mb-0">
			<div class="card-body pb-0">
				<ngx-simplebar class="mx-n3" [style]="isFullHeight?'height: calc(100vh - 460px)':''" auto-hide="false">
					@for (comment of comments; track $index) {
						<app-message
							[imageSrc]="comment?.utilisateur?.avatar?.url"
							[imageAlt]="comment?.utilisateur?.nom"
							[userName]="comment?.utilisateur?.nom"
							[date]="comment?.commentedAt | dateFormatPipe"
							[message]="comment?.message"
						>
						</app-message>
					}
				</ngx-simplebar>
			</div>
		</div>

		<!-- Commentaire Form =========== -->
		<form [hidden]="hiddenForm" [formGroup]="form">
			<div class="row g-3">
				<div class="col-xl-12" formGroupName="commentaireForm">
					<textarea formControlName="message" class="form-control bg-light border-light" rows="3" placeholder="Saisissez un commentaire..."></textarea>
				</div>
				<div class="col-xl-12 text-center">
					<button [disabled]="commentairesForm.invalid" class="btn btn-secondary rounded-pill w-md" (click)="onAddCommentaire()">Ajouter</button>
				</div>
			</div>
		</form>
	</div>
</div>
